import { render, staticRenderFns } from "./StudentsBlacklist.vue?vue&type=template&id=74410d62&scoped=true&"
import script from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
export * from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./StudentsBlacklist.vue?vue&type=style&index=0&id=74410d62&lang=scss&scoped=true&"
import style1 from "./StudentsBlacklist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74410d62",
  null
  
)

export default component.exports